export default __webpack_public_path__ + "static/media/ba-political-science.4033ed8c.pdf";